import { View } from 'react-native'
import { useAllowedDealTypes } from '@order/hooks/useDeals'

import SingleVisionLarge from './sections/SingleVisionLarge'
import Progressives from './sections/Progressives'
import Office from './sections/Office'
import AllDeals from './sections/AllDeals'
import TBGO from './sections/TBGO'
import { useConfigCondition } from 'features/config/useConfigCondition'
import OpticalMeasureDevTile from 'features/debug/OpticalMeasureDevTile'

export default function IntroTilesSV() {
  const types = useAllowedDealTypes()
  const showAllDeals = useConfigCondition('intro:allDeals')
  return (
    <>
      <View className="gap-8 p-8 pt-0">
        <OpticalMeasureDevTile />
        <SingleVisionLarge />
        <View className="w-full flex-row gap-8">
          <Progressives />
          <Office />
        </View>
        {showAllDeals && <AllDeals />}
        {types.includes('tgbo') && <TBGO />}
      </View>
    </>
  )
}
